module.exports = __webpack_public_path__ + "img/tutorial1.ab0a8014.png";